import { render, staticRenderFns } from "./ProjectArts.vue?vue&type=template&id=2329eb6f&scoped=true&"
import script from "./ProjectArts.vue?vue&type=script&lang=js&"
export * from "./ProjectArts.vue?vue&type=script&lang=js&"
import style0 from "./ProjectArts.vue?vue&type=style&index=0&id=2329eb6f&lang=scss&scoped=true&"
import style1 from "./ProjectArts.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2329eb6f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
